import { MenuItemProps } from 'piral'
import * as React from 'react'

export default function MenuItem(props: MenuItemProps) {
    return (
        <>{props.children}</>
    )
}
